import { css } from '@emotion/react'
import geladaSemiBoldFont from '@/assets/fonts/GeladaRC3-SemiBold.otf'
import geladaBlackFont from '@/assets/fonts/GeladaRC3-Black.otf'

export const GlobalStyles = css`
  @font-face {
    font-family: 'Gelada-SemiBold';
    src: url('${geladaSemiBoldFont}') format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: 'Gelada-Black';
    src: url('${geladaBlackFont}') format('opentype');
    font-display: swap;
  }

  :root {
    --font-gelada-semi-bold: 'Gelada-SemiBold', sans-serif;
    --font-gelada-black: 'Gelada-Black', sans-serif;
  }

  * {
    margin: 0;
    padding: 0;
    border: 0;
  }

  html {
    height: 100%;
  }

  body {
    height: 100%;
    min-height: 100%;
    background-color: var(--foundation-bg-primary-weak);
  }

  .super-classe {
    color: #d246d9;
  }

  #app,
  #view-consumer-phone-modals,
  #order-details-modal,
  #note-print,
  #scheduled-orders-print-container,
  #print-restitution,
  #cash-balance-print {
    font:
      16px 'Roboto',
      Roboto,
      sans-serif;
    line-height: 22px;
    margin: 0 auto;
    position: relative;
  }

  .hidden-page {
    display: none;
  }

  .overlay {
    z-index: 2147483603;
  }

  @media print {
    .hidden-page {
      display: block !important;
    }

    .hidden-print,
    #spr-live-chat-app,
    #order-details-modal,
    div[data-testid='survey-root'] {
      display: none !important;
    }

    #app {
      height: auto;
    }

    #app :not(.hidden-page) {
      display: none !important;
    }
  }

  table {
    border-collapse: collapse;
  }

  @page {
    margin: 0;
  }
`
